/**
 * Created by jtrav on 4/28/2019.
 */
import React,{ Component } from "react";
import { Link } from "react-router-dom";
import {connect} from "react-redux";
import classnames from 'classnames';
import { getZones} from "../../../actions/actionZones";
import { Row, Col, Table, Card, CardBody, CardHeader, Button, TabContent, TabPane, Nav, NavItem, NavLink} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";
import moment from "moment";
import ReactJson from 'react-json-view';
import {getLicenses} from "../../../actions/actionSystemInfo";
import iconNo from "../../../../assets/images/icon_no.svg";
import iconYes from "../../../../assets/images/icon_yes.svg";

const routes = [
    {name: "Home", path:"/userdashboard", isActive: false},
    {name: "Zone", path:"/zones", isActive: false},
    {name: "ViewZone", path:"/viewzone", isActive: true},
];

class ViewZone extends Component{
    constructor(props){
        super(props);
        this.state = {
            currentZone: null,
            auto_scaling: false,
            activeTab: 0
        };
    }

    toggle(tab){
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }
  
    componentDidMount(){
        this.props.getZones();
        this.props.getLicenses()
            .then(() => {
                const {licenses} = this.props;
                for (let i in licenses) {
                    if (licenses[i].features && licenses[i].features.auto_scaling === true) {
                        this.setState({auto_scaling: true})
                    }
                }
            });
    }
      
    UNSAFE_componentWillReceiveProps(nextProps){
        if(nextProps.zones.length > 0){        	
            let currentZone = nextProps.zones.find(zone => zone.zone_id === this.props.match.params.id);
            this.setState({currentZone: currentZone});
        }
    }


    render(){
        const {currentZone} = this.state;
        return (
            <div className="profile-page"> 
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                               <strong>View Deployment Zone</strong>
                                {currentZone ? <Link className="pull-right" to={{ pathname: `/updatezone/${currentZone.zone_id}`}}>
                                    <Button className = "reset-btn" size="sm" color="primary"> Edit Zone </Button> </Link> :" "}
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">
                                        <div className="profile-table">
                                            {currentZone?
                                                <Table >
                                                    <tbody>
                                                        <tr><td><h4>Zone Id</h4></td><td>{currentZone.zone_id ? currentZone.zone_id : "-"}</td></tr>
                                                        <tr><td><h4>Zone Name</h4></td><td>{currentZone.zone_name ? currentZone.zone_name : "-"}</td></tr>
                                                        <tr><td><h4>Managers</h4></td><td>{currentZone.managers.length ? currentZone.managers.length : "-"}</td></tr>
                                                        <tr><td><h4>Agents</h4></td><td>{currentZone.servers.length ? currentZone.servers.length: "-"}</td></tr>
                                                        <tr><td><h4>Sessions</h4></td><td>{currentZone.num_kasms ? currentZone.num_kasms : "-"}</td></tr>
                                                        <tr><td><h4>Available Cores</h4></td><td>{currentZone.available_cores ? currentZone.available_cores: "-"}</td></tr>
                                                        <tr><td><h4>Available Memory (GB)</h4></td><td>{currentZone.available_memory ? (currentZone.available_memory / 1000 / 1000 / 1000).toFixed(1): "-"}</td></tr>
                                                    </tbody>
                                                </Table> :" "}
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        );}
}

ViewZone.propTypes = {
    getZones: Proptypes.func.isRequired,
    zones: Proptypes.array,
    licenses: Proptypes.array,
    match: Proptypes.object,
};

export default connect(state => 
    ({
        zones: state.zones.zones || [],
        licenses: state.system_info.licenses
    }),
dispatch => 
    ({
        getLicenses: () => dispatch(getLicenses()),
        getZones: () => dispatch(getZones()),
    }))(ViewZone);